import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import HexaCalculator from '../views/calculator/HexaCalculator.vue'
import ScrollCalculator from '../views/calculator/ScrollCalculator.vue'
import JewelSimulator from '../views/simulator/JewelSimulator.vue'
import ExpCalculator from '../views/calculator/ExpCalculator.vue'
import BackCalc from '../views/calculator/BackCalc.vue'
import HexaStats from '../views/simulator/HexaStatSimulator.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/calculator/hexa',
    name: 'HexaCalculator',
    component: HexaCalculator
  },
  {
    path: '/calculator/scroll',
    name: 'ScrollCalculator',
    component: ScrollCalculator
  },
  {
    path: '/calculator/exp',
    name: 'ExpCalculator',
    component: ExpCalculator
  },
  {
    path: '/calculator/backcalc',
    name: 'BackCalc',
    component: BackCalc
  },
  {
    path: '/simulator/jewel',
    name: 'JewelSimulator',
    component: JewelSimulator
  },
  {
    path: '/simulator/hexa-stats',
    name: 'HexaStats',
    component: HexaStats
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

export default router 